/**
 * Engagement API Endpoints
 * Framework-agnostic endpoint definitions for engagement module (quiz-task, image-task, etc.)
 * All endpoints require program_id query parameter
 */

export const ENGAGEMENT_ENDPOINTS = {
  /** Get engagement types - filtered by engagement_page parameter */
  types: 'engagement/engagementtypes',

  /** Get all engagements with filters and pagination */
  list: 'engagement/list-engagement',

  /** Get single engagement detail for editing */
  viewEngagement: 'engagement/view-engagement',

  /** Create/Update engagement (quiz, image, content) */
  createEngagementContent: 'engagement/create-engagement-content',

  /** Create/Update quiz + content task (new API - used for content & learning) */
  createQuizContentTask: 'engagement/create-quiz-content-task',

  /** Delete question and options from quiz/content engagement */
  deleteQuestionAndOptions: 'engagement/delete-question-and-options',

  /** Create/Update image engagement (picture task specific) */
  createImageTask: 'engagement/create-image-task',

  /** Upload instruction image for image-task templates */
  uploadInstructionImage: 'engagement/upload-instruction-image',

  /** Calculate points for sub-tasks (customized reward type) */
  pointCalcEngagement: 'engagement/point-calc-engagement',

  /** Get whitelisted users for engagement */
  engagementUsersList: 'engagement/engagement-users-list',

  /** Whitelist users to engagement (zone-based or all) - used by all engagement types */
  engagementWhitelistUsers: 'engagement/engagement-whitelist-users',

  /** Disable/toggle user status in engagement */
  engagementUsersDisable: 'engagement/engagement-users-disable',

  /** Deactivate entire engagement */
  deactivateEngagement: 'engagement/deactivate-engagement',
} as const;

/**
 * User Role API Endpoints
 * Used for role dropdowns in engagement configuration
 */
export const USER_ROLE_ENDPOINTS = {
  /** Get all user roles */
  getRoles: 'user-role/list-roles',
} as const;

/**
 * Config API Endpoints for Zone Selection
 * Used in engagement whitelist zone configuration
 * Uses geo endpoints (not config endpoints)
 */
export const CONFIG_ENDPOINTS = {
  /** Get all regions */
  regions: 'geo/get-region',

  /** Get states by region */
  states: 'geo/get-state',

  /** Get cities by state */
  cities: 'geo/get-city',
} as const;
